import cn from 'classnames';
import Image from 'next/image';
import img1 from 'react-scale/public/static/images/pages/homepage/build-ai/1.jpg';
import img2 from 'react-scale/public/static/images/pages/homepage/build-ai/2.jpg';
import img3 from 'react-scale/public/static/images/pages/homepage/build-ai/3.jpg';
import img4 from 'react-scale/public/static/images/pages/homepage/build-ai/4.jpg';
import img5 from 'react-scale/public/static/images/pages/homepage/build-ai/5.jpg';
import img6 from 'react-scale/public/static/images/pages/homepage/build-ai/6.jpg';
import img7 from 'react-scale/public/static/images/pages/homepage/build-ai/7.jpg';
import img8 from 'react-scale/public/static/images/pages/homepage/build-ai/8.jpg';

const CurationIllustration = ({ inverted = false }) => {
  return (
    <div
      className={cn(
        inverted
          ? 'lg:-translate-x-10 3xl:-translate-x-18'
          : 'lg:translate-x-10 3xl:translate-x-18',
        'w-[648px] aspect-[648/432] rounded-lg shadow-xl xl:shadow-super max-w-full lg:max-w-[50%] xl:max-w-none lg:mb-0 mb-9 select-none bg-white'
      )}
    >
      <div className="flex w-full h-full text-black space-x-0 md:space-x-4 lg:space-x-0 xl:space-x-4 overflow-hidden">
        <div className="w-20 sm:w-28 lg:w-20 xl:w-28 p-2 sm:p-3 lg:p-2 xl:p-3 flex flex-col h-full">
          <NucleusSvg />
          <div className="bg-[#6B80D2] flex items-center justify-center text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-3 rounded-[4px] mt-2 sm:mt-4 lg:mt-2 xl:mt-4 mb-2 sm:mb-[10px] lg:mb-2 xl:mb-[10px] py-1 space-x-1 text-white font-[500]">
            Create Dataset{' '}
            <svg
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="h-2 sm:h-[10px] lg:h-2 xl:h-[10px] aspect-square"
            >
              <path
                d="M7.332 4.052H5.388V2.108a.432.432 0 0 0-.432-.432h-.432a.432.432 0 0 0-.432.432v1.944H2.148a.432.432 0 0 0-.432.432v.432c0 .238.193.432.432.432h1.944v1.944c0 .238.193.432.432.432h.432a.432.432 0 0 0 .432-.432V5.348h1.944a.432.432 0 0 0 .432-.432v-.432a.432.432 0 0 0-.432-.432Z"
                fill="#fff"
              />
            </svg>
          </div>
          <div className="border-alto border-y border-x rounded-[4px] mb-2 sm:mb-[10px] lg:mb-2 xl:mb-[10px]">
            <div className="text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-tight p-2 sm:py-[6px] lg:p-2 xl:py-[6px] px-2 border-b border-alto">
              MS COCO
            </div>
            <ul className="p-2 space-y-2 sm:space-y-[10px] lg:space-y-2 xl:space-y-[10px] text-emperor">
              <li className="flex items-center space-x-1 leading-tight text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px]">
                <svg
                  viewBox="0 0 13 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-2 sm:h-3 lg:h-2 xl:h-3 aspect-square"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.658 3.85a.153.153 0 0 1-.215 0L9.59 3a.151.151 0 0 1 0-.214l.588-.587a.458.458 0 0 1 .647 0l.42.42a.455.455 0 0 1 .002.642l-.002.001-.588.587ZM6.045 8.257l-1.025.308a.114.114 0 0 1-.142-.142l.307-1.027a1.22 1.22 0 0 1 .306-.512l3.555-3.558c.06-.059.156-.059.215 0l.85.852c.06.06.06.156 0 .215L6.558 7.952a1.219 1.219 0 0 1-.512.306Zm4.52-1.923v3.453a1.22 1.22 0 0 1-1.219 1.22H3.658a1.22 1.22 0 0 1-1.218-1.22V4.099A1.22 1.22 0 0 1 3.658 2.88h3.454a.406.406 0 1 1 0 .813H3.658a.407.407 0 0 0-.406.406v5.689c0 .224.182.406.406.406h5.688a.407.407 0 0 0 .406-.406V6.335a.406.406 0 1 1 .813 0Z"
                    fill="#6B80D2"
                  />
                </svg>
                <span>Overview</span>
              </li>
              <li className="flex items-center space-x-1 leading-tight text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px]">
                <svg
                  viewBox="0 0 13 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-2 sm:h-3 lg:h-2 xl:h-3 aspect-square"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.973 11.007H2.035a.406.406 0 1 1 0-.813h8.938a.406.406 0 1 1 0 .813Zm-.406-1.219H8.942a.406.406 0 0 1-.407-.406V4.913c0-.224.182-.406.407-.406h1.625c.224 0 .406.182.406.406v4.469a.406.406 0 0 1-.406.406Zm-3.25-6.906c.224 0 .406.182.406.406v6.094a.406.406 0 0 1-.406.406H5.692a.406.406 0 0 1-.407-.406V3.288c0-.224.182-.406.407-.406h1.625Zm-3.25 3.25c.224 0 .406.182.406.406v2.844a.406.406 0 0 1-.406.406H2.442a.406.406 0 0 1-.407-.406V6.538c0-.224.182-.406.407-.406h1.625Z"
                    fill="#D4D4D4"
                  />
                </svg>
                <span>Charts</span>
              </li>
              <li className="flex items-center space-x-1 leading-tight text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px]">
                <svg
                  viewBox="0 0 13 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-2 sm:h-3 lg:h-2 xl:h-3 aspect-square"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.8 5.175a5.274 5.274 0 0 0-6.057 6.063.143.143 0 0 1-.202.152 4.87 4.87 0 1 1 6.411-6.417.143.143 0 0 1-.151.202Zm-.852.336c.274 0 .548.025.818.073a.24.24 0 0 1 .124.405l-5.334 5.338a.24.24 0 0 1-.405-.124 4.719 4.719 0 0 1-.073-.819c0-2.69 2.18-4.872 4.87-4.873Z"
                    fill="#D4D4D4"
                  />
                </svg>
                <span>Slices (12)</span>
              </li>
              <li className="flex items-center space-x-1 leading-tight text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px]">
                <svg
                  viewBox="0 0 13 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-2 sm:h-3 lg:h-2 xl:h-3 aspect-square"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m9.649 2.88-2.758.001c-.323 0-.633.129-.861.358L1.81 7.46a.611.611 0 0 0 0 .864l3.313 3.314a.61.61 0 0 0 .863 0l4.22-4.222c.228-.229.356-.538.356-.861V3.795a.914.914 0 0 0-.913-.915Zm-.92 2.446a.61.61 0 1 1 .611-.611.61.61 0 0 1-.61.611Z"
                    fill="#D4D4D4"
                  />
                </svg>
                <span>Autotags</span>
              </li>
            </ul>
          </div>

          <div className="border-alto border-y border-x rounded-[4px] p-2 flex items-center space-x-1 mb-1 sm:mb-[10px] lg:mb-2 xl:mb-[10px]">
            <svg
              viewBox="0 0 13 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="h-2 sm:h-3 lg:h-2 xl:h-3 aspect-square"
            >
              <path
                d="M1.45 7.04v2.02c0 .28.226.505.505.505h.505v-3.03h-.505a.504.504 0 0 0-.505.505Zm7.323-2.525H7.005v-1.01a.504.504 0 1 0-1.01 0v1.01H4.228c-.698 0-1.263.565-1.263 1.262v4.293c0 .557.453 1.01 1.01 1.01h5.05a1.01 1.01 0 0 0 1.01-1.01V5.777c0-.697-.565-1.262-1.262-1.262ZM5.49 9.565H4.48V9.06h1.01v.505ZM4.985 7.67a.631.631 0 1 1 0-1.262.631.631 0 0 1 0 1.262Zm2.02 1.894h-1.01V9.06h1.01v.505Zm1.515 0H7.51V9.06h1.01v.505ZM8.015 7.67a.631.631 0 1 1 0-1.262.631.631 0 0 1 0 1.262Zm3.03-1.136h-.505v3.03h.505c.28 0 .505-.226.505-.505V7.04a.504.504 0 0 0-.505-.505Z"
                fill="#000"
              />
            </svg>
            <span className="flex-1 text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] font-[500] leading-tight">
              Models
            </span>
            <svg
              viewBox="0 0 11 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="h-2 sm:h-3 lg:h-2 xl:h-3 aspect-square"
            >
              <path
                d="m4.125 8.69 2.75-2.75-2.75-2.75"
                stroke="#000"
                strokeWidth=".917"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <ul className="p-2 space-y-1 sm:space-y-[10px] lg:space-y-2 xl:space-y-[10px] text-emperor">
            <li className="flex items-center space-x-1 text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-3">
              <svg
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="h-2 sm:h-3 lg:h-2 xl:h-3 aspect-square"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.393 9.242c.43-.112.737-.49.759-.935l.356-2.994a2.993 2.993 0 0 1 2.191-2.526.808.808 0 0 1 1.606 0 2.993 2.993 0 0 1 2.192 2.526l.356 2.994c.021.444.329.823.759.935a.485.485 0 0 1-.132.952H2.524a.485.485 0 0 1-.131-.952Zm4.11 2.577a1.222 1.222 0 0 1-1.221-1.112.101.101 0 0 1 .096-.106H7.62a.101.101 0 0 1 .102.106 1.223 1.223 0 0 1-1.22 1.112Z"
                  fill="#D4D4D4"
                />
              </svg>
              <span>Jobs</span>
            </li>
            <li className="flex items-center space-x-1 text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-3">
              <svg
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="h-2 sm:h-3 lg:h-2 xl:h-3 aspect-square"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.965 11.176a.583.583 0 0 1-.93 0C4.69 9.757 2.03 8.663 2.03 6.01c0-2.011 1.566-3.54 4.469-3.54 2.903 0 4.469 1.529 4.469 3.54 0 2.653-2.66 3.747-4.004 5.166Zm3.185-6.334a.178.178 0 0 0-.256-.117c-.706.381-1.962.59-3.394.59-1.432 0-2.682-.209-3.389-.59a.178.178 0 0 0-.255.117l-.001.003a.2.2 0 0 0 .064.211c.767.596 2.039 1.074 3.584 1.074s2.816-.478 3.584-1.074a.2.2 0 0 0 .064-.211l-.001-.003Z"
                  fill="#D4D4D4"
                />
              </svg>
              <span>Guides</span>
            </li>
            <li className="flex items-center space-x-1 text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-3">
              <svg
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="h-2 sm:h-3 lg:h-2 xl:h-3 aspect-square"
              >
                <path
                  d="M8.125 4.502H2.437a.813.813 0 0 0-.812.813v5.687c0 .45.364.813.813.813h5.687a.812.812 0 0 0 .813-.813V5.315a.813.813 0 0 0-.813-.813Zm2.438-2.437H4.875a.813.813 0 0 0-.813.812v.813c0 .224.182.406.407.406h3.656c.673 0 1.219.546 1.219 1.219V8.97c0 .225.182.406.406.406h.813a.813.813 0 0 0 .812-.812V2.877a.813.813 0 0 0-.813-.812Z"
                  fill="#D4D4D4"
                />
              </svg>
              <span>Docs</span>
            </li>
          </ul>

          <div className="mt-auto flex items-center p-1 sm:p-[6px] lg:p-1 xl:p-[6px] text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-none justify-center space-x-[2px] text-emperor border-alto border-y border-x rounded-[4px]">
            <svg
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="h-[6px] sm:h-3 lg:h-[6px] xl:h-3 aspect-square"
            >
              <g clipPath="url(#a)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.688 2.625c0-.207.167-.375.375-.375h1.874c.208 0 .376.168.376.375v1.5a.375.375 0 0 1-.376.375H8.063a.375.375 0 0 1-.376-.375v-1.5ZM8.063 7.5h1.874c.208 0 .376.168.376.375v1.5a.375.375 0 0 1-.376.375H8.063a.375.375 0 0 1-.376-.375v-1.5c0-.207.168-.375.375-.375Zm-.376-2.25c0-.207.168-.375.375-.375h1.876c.207 0 .374.168.374.375v1.5a.375.375 0 0 1-.374.375H8.062a.375.375 0 0 1-.374-.375v-1.5Zm-3-2.625c0-.207.168-.375.375-.375h1.875c.208 0 .375.168.375.375v1.5a.375.375 0 0 1-.375.375H5.063a.375.375 0 0 1-.375-.375v-1.5ZM5.063 7.5h1.875c.208 0 .375.168.375.375v1.5a.375.375 0 0 1-.375.375H5.063a.375.375 0 0 1-.375-.375v-1.5c0-.207.168-.375.375-.375Zm-.375-2.25c0-.207.168-.375.375-.375h1.875c.208 0 .375.168.375.375v1.5a.375.375 0 0 1-.375.375H5.063a.375.375 0 0 1-.375-.375v-1.5Zm-3-2.625c0-.207.168-.375.375-.375h1.876c.207 0 .374.168.374.375v1.5a.375.375 0 0 1-.375.375H2.063a.375.375 0 0 1-.376-.375v-1.5ZM2.063 7.5h1.876c.207 0 .374.168.374.375v1.5a.375.375 0 0 1-.375.375H2.063a.375.375 0 0 1-.376-.375v-1.5c0-.207.168-.375.375-.375Zm-.374-2.25c0-.207.167-.375.375-.375h1.874c.208 0 .376.168.376.375v1.5a.375.375 0 0 1-.375.375H2.062a.375.375 0 0 1-.374-.375v-1.5Z"
                  fill="#6B80D2"
                />
              </g>
              <defs>
                <clipPath id="a">
                  <path fill="#fff" d="M0 0h12v12H0z" />
                </clipPath>
              </defs>
            </svg>
            <span>Other Products</span>
          </div>
        </div>

        <div className="flex-1 flex flex-col px-2 sm:px-3 lg:px-2 xl:px-3 pt-[10px] sm:pt-4 lg:pt-[10px] xl:pt-4 w-[calc(100%-80px)] sm:w-[calc(100%-112px)] lg:w-[calc(100%-80px)] xl:w-[calc(100%-112px)]">
          <div className="flex items-center space-x-1 mb-2 sm:mb-3 lg:mb-[10px] xl:mb-3">
            <h3 className="text-[9px] sm:text-[11px] lg:text-[9px] xl:text-[11px] leading-none font-[500]">
              MS COCO
            </h3>
            <span className="text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-none">
              ds_bwm61zzb8mjksanms4wg
            </span>
          </div>

          <div className="grid grid-cols-4 gap-1 mb-2 sm:mb-3 lg:mb-2 xl:mb-3">
            <div className="bg-silver aspect-[121/68] w-full">
              <Image src={img1} alt="img1" />
            </div>
            <div className="bg-silver aspect-[121/68] w-full">
              <Image src={img2} alt="img2" />
            </div>
            <div className="bg-silver aspect-[121/68] w-full">
              <Image src={img3} alt="img3" />
            </div>
            <div className="bg-silver aspect-[121/68] w-full">
              <Image src={img4} alt="img4" />
            </div>
            <div className="bg-silver aspect-[121/68] w-full">
              <Image src={img5} alt="img5" />
            </div>
            <div className="bg-silver aspect-[121/68] w-full">
              <Image src={img6} alt="img6" />
            </div>
            <div className="bg-silver aspect-[121/68] w-full">
              <Image src={img7} alt="img7" />
            </div>
            <div className="bg-silver aspect-[121/68] w-full">
              <Image src={img8} alt="img8" />
            </div>
          </div>

          <div className="flex items-center justify-between mb-[6px] sm:mb-[10px]">
            <span className="text-[9px] sm:text-[11px] lg:text-[9px] xl:text-[11px] leading-none font-[500]">
              MS COCO
            </span>
            <div className="bg-[#6B80D2] text-white font-[500] flex items-center justify-center text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-3 rounded-[4px] py-1 sm:px-1 px-[6px]">
              See All Insights
            </div>
          </div>

          <div className="grid grid-cols-4 gap-1 mb-2 sm:mb-3 lg:mb-2 xl:mb-3">
            <div className="border-alto border-y border-x rounded-[4px] p-2 sm:p-[14px] lg:p-2 xl:p-[14px] relative space-y-0 sm:space-y-1">
              <p className="text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-[11px] font-[500] text-silver">
                ITEMS
              </p>
              <p className="text-[8px] sm:text-[10px] lg:text-[8px] xl:text-[10px] leading-[11px] font-[500]">
                123289
              </p>
              <svg
                className="absolute bottom-2 right-2"
                width="11"
                height="11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m4.125 8.25 2.75-2.75-2.75-2.75"
                  stroke="#000"
                  strokeWidth=".917"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="border-alto border-y border-x rounded-[4px] p-2 sm:p-[14px] lg:p-2 xl:p-[14px] relative space-y-0 sm:space-y-1">
              <p className="text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-[11px] font-[500] text-silver">
                SLICES
              </p>
              <p className="text-[8px] sm:text-[10px] lg:text-[8px] xl:text-[10px] leading-[11px] font-[500]">
                12
              </p>
              <svg
                className="absolute bottom-2 right-2"
                width="11"
                height="11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m4.125 8.25 2.75-2.75-2.75-2.75"
                  stroke="#000"
                  strokeWidth=".917"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="border-alto border-y border-x rounded-[4px] p-2 sm:p-[14px] lg:p-2 xl:p-[14px] relative space-y-0 sm:space-y-1">
              <p className="text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-[11px] font-[500] text-silver">
                AUTOTAGS
              </p>
              <p className="text-[8px] sm:text-[10px] lg:text-[8px] xl:text-[10px] leading-[11px] font-[500]">
                0
              </p>
              <svg
                className="absolute bottom-2 right-2"
                width="11"
                height="11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m4.125 8.25 2.75-2.75-2.75-2.75"
                  stroke="#000"
                  strokeWidth=".917"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="border-alto border-y border-x rounded-[4px] p-2 sm:p-[14px] lg:p-2 xl:p-[14px] relative space-y-0 sm:space-y-1">
              <p className="text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-[11px] font-[500] text-silver">
                MODEL RUNS
              </p>
              <p className="text-[8px] sm:text-[10px] lg:text-[8px] xl:text-[10px] leading-[11px] font-[500]">
                2
              </p>
              <svg
                className="absolute bottom-2 right-2"
                width="11"
                height="11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m4.125 8.25 2.75-2.75-2.75-2.75"
                  stroke="#000"
                  strokeWidth=".917"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>

          <div className="border-alto border-y border-x rounded-[4px] p-[10px] sm:p-4 lg:p-[10px] xl:p-4 mb-2 sm:mb-3 lg:mb-2 xl:mb-3">
            <div className="flex items-center mb-2 sm:mb-4 lg:mb-2 xl:mb-4">
              <div className="flex-1 space-y-0 sm:space-y-1 lg:space-y-0 xl:space-y-1">
                <p className="text-[6px] sm:text-[10px] lg:text-[7px] xl:text-[10px] leading-tight font-[500]">
                  Object Class Distribution
                </p>
                <p className="text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-tight font-[500] text-silver">
                  Ground Truth
                </p>
              </div>
              <div className="flex space-x-2 sm:space-x-3 lg:space-x-2 xl:space-x-3">
                <div className="border-alto border-y border-x rounded-[4px] p-[3px] sm:px-[6px] sm:py-[5px] lg:p-1 xl:px-[6px] xl:py-[5px] space-x-1 w-20 sm:w-[120px] lg:w-24 xl:w-[120px] flex">
                  <svg width="8" height="7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g
                      clipPath="url(#a)"
                      stroke="#525252"
                      strokeWidth=".583"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3.608 5.542a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667ZM6.525 6.125 5.256 4.856" />
                    </g>
                    <defs>
                      <clipPath id="a">
                        <path fill="#fff" d="M.4 0h7v7h-7z" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span className="text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-none text-emperor">
                    Search
                  </span>
                </div>
                <div className="flex items-center space-x-1">
                  <svg width="10" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x=".4" y=".96" width="9.08" height="9.08" rx="1.5" fill="#6B80D2" />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.975 3.433a.402.402 0 0 1 .507-.006c.171.145.192.396.043.567L4.705 7.38a.76.76 0 0 1-.166.155.801.801 0 0 1-1.11-.225L2.316 5.644a.403.403 0 0 1 .112-.555.405.405 0 0 1 .444 0l1.17.774 2.926-2.436.006.006Z"
                      fill="#fff"
                    />
                  </svg>
                  <span className="text-[6px] sm:text-[8px] lg:text-[6px] xl:text-[8px] leading-none text-emperor">
                    Showing 20 of 80 Results
                  </span>
                </div>
              </div>
            </div>
            <svg
              viewBox="0 0 462 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="h-7 sm:h-[42px] lg:h-8 xl:h-[42px] w-full"
            >
              <path
                d="M.24 11.3h461M.24 6.3h461M.24 16.3h461M.24 26.3h461M.24 31.3h461M.24 36.3h461M.24 41.3h461M.24 21.3h461"
                stroke="#D4D4D4"
                strokeWidth=".3"
              />
              <path
                fill="#6B80D2"
                d="M7.255 0H24.72v41.48H7.255zM27.995 33.838H45.46v7.641H27.995zM48.735 34.93H66.2v6.549H48.735zM69.474 37.113h17.465v4.366H69.474zM90.214 37.113h17.465v4.366H90.214zM110.954 38.205h17.465v3.275h-17.465zM131.694 39.296h17.465v2.183h-17.465zM152.433 39.296h17.465v2.183h-17.465zM173.173 39.296h17.465v2.183h-17.465zM193.913 39.296h17.465v2.183h-17.465zM214.653 39.296h17.465v2.183h-17.465zM235.393 39.296h17.465v2.183h-17.465zM256.132 39.296h17.465v2.183h-17.465zM276.872 39.296h17.465v2.183h-17.465zM297.612 39.296h17.465v2.183h-17.465zM318.352 39.296h17.465v2.183h-17.465zM339.091 39.296h17.465v2.183h-17.465zM359.831 39.296h17.465v2.183h-17.465zM380.571 39.296h17.465v2.183h-17.465zM401.311 39.296h17.465v2.183h-17.465zM422.05 39.296h17.465v2.183H422.05zM442.79 39.296h17.465v2.183H442.79z"
              />
            </svg>
          </div>

          <div className="border-alto border-y border-x rounded-[4px] p-4 mb-3" />
        </div>
      </div>
    </div>
  );
};

const NucleusSvg = () => (
  <svg
    width={54}
    height={13}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="min-h-[13px]"
  >
    <g clipPath="url(#a)">
      <path d="M5.11 5.67v1.62l1.417.81.354-1.755-1.772-.675Z" fill="#C88BC4" />
      <path d="M7.927 5.67v1.62l-1.4.81V6.48l1.4-.81Z" fill="#6B80D2" />
      <path d="m5.11 5.67 1.4-.81 1.4.81-1.4.81-1.4-.81Z" fill="#BBDEF2" />
      <path d="M5.11.81v1.62l4.218 2.43v1.62l1.4.81.321-3.426L5.11.81Z" fill="#C88BC4" />
      <path d="M10.729 4.05v3.24l1.4-.81V3.24l-1.4.81Z" fill="#6B80D2" />
      <path d="m10.729 4.05 1.4-.81L6.527 0 5.109.81l5.62 3.24Z" fill="#BBDEF2" />
      <path d="m2.308 10.53 1.4-.81V4.86l1.4-.81V2.43l-3.12 1.435.32 6.665Z" fill="#6B80D2" />
      <path d="m2.308 4.05 2.801-1.62-1.4-.81L.906 3.24l1.4.81Z" fill="#BBDEF2" />
      <path d="m2.308 4.05-1.4-.81v6.48l1.4.81V4.05Z" fill="#C88BC4" />
      <path
        d="m12.13 8.1-1.402-.81-4.201 2.43-1.418-.81-1.4.81 2.818 1.991L12.129 8.1Z"
        fill="#BBDEF2"
      />
      <path d="M6.527 11.34 3.708 9.72v1.62l2.819 1.62v-1.62Z" fill="#C88BC4" />
      <path d="M6.527 11.34v1.62l5.602-3.24V8.1l-5.602 3.24Z" fill="#6B80D2" />
    </g>
    <path
      d="M18.033 10.48V3.676h1.02l3.315 4.821V3.676h1.099v6.804h-1.021L19.13 5.659v4.821h-1.098Zm11.028-4.977v4.977h-.924l-.116-.632c-.376.46-.888.69-1.536.69-.583 0-1.056-.181-1.42-.544-.362-.363-.544-.946-.544-1.75v-2.74h1.05v2.633c0 .486.097.856.292 1.109.194.252.483.379.865.379.402 0 .716-.146.943-.438.227-.298.34-.703.34-1.215V5.503h1.05Zm5.622 3.188c-.097.577-.347 1.03-.748 1.361-.402.324-.917.486-1.546.486-.492 0-.927-.103-1.302-.31a2.218 2.218 0 0 1-.875-.905c-.201-.389-.302-.836-.302-1.341 0-.506.104-.95.311-1.332a2.17 2.17 0 0 1 .875-.884c.383-.214.823-.321 1.322-.321.622 0 1.131.165 1.526.496.395.324.642.768.739 1.331h-1.079a1.212 1.212 0 0 0-.428-.68 1.233 1.233 0 0 0-.787-.253c-.421 0-.761.153-1.02.457-.253.305-.38.7-.38 1.186 0 .492.127.894.38 1.205.259.305.599.457 1.02.457.324 0 .593-.084.807-.253.214-.175.353-.408.418-.7h1.069Zm.842-5.015h1.05v6.804h-1.05V3.676Zm1.894 4.325c0-.512.1-.959.301-1.341a2.19 2.19 0 0 1 .855-.894c.37-.214.791-.321 1.264-.321.48 0 .9.097 1.264.292.369.194.657.47.865.826.214.356.324.774.33 1.254 0 .13-.01.262-.029.398h-3.752v.059c.026.434.162.777.408 1.03.247.253.574.379.982.379.324 0 .596-.075.817-.224.22-.155.366-.372.437-.65h1.05c-.091.505-.337.92-.739 1.243-.395.324-.891.486-1.487.486-.518 0-.972-.103-1.36-.31a2.283 2.283 0 0 1-.895-.895c-.207-.382-.311-.826-.311-1.332Zm3.81-.554c-.045-.363-.191-.644-.437-.845-.24-.208-.545-.311-.914-.311a1.34 1.34 0 0 0-.894.32 1.224 1.224 0 0 0-.428.836h2.673Zm6.38-1.944v4.977h-.924l-.117-.632c-.375.46-.887.69-1.535.69-.584 0-1.057-.181-1.42-.544-.362-.363-.544-.946-.544-1.75v-2.74h1.05v2.633c0 .486.097.856.291 1.109.195.252.483.379.866.379.401 0 .716-.146.942-.438.227-.298.34-.703.34-1.215V5.503h1.05Zm1.87 3.334c.02.26.14.473.36.642.226.162.518.243.874.243.318 0 .574-.058.768-.175.201-.123.301-.285.301-.486 0-.169-.045-.295-.136-.38a.757.757 0 0 0-.369-.174 5.877 5.877 0 0 0-.7-.117 6.7 6.7 0 0 1-1.079-.204 1.575 1.575 0 0 1-.68-.418c-.169-.194-.253-.454-.253-.777 0-.305.084-.574.253-.807.175-.24.411-.425.71-.554.304-.13.647-.195 1.03-.195.628 0 1.137.14 1.526.418.395.279.609.67.641 1.176h-1.02a.766.766 0 0 0-.34-.554c-.201-.149-.454-.223-.759-.223-.304 0-.55.058-.738.175-.188.116-.282.275-.282.476 0 .15.045.262.136.34a.961.961 0 0 0 .36.156c.142.026.372.058.69.097.427.045.787.117 1.078.214.292.09.525.24.7.447.175.2.263.476.263.826 0 .311-.091.587-.272.826a1.77 1.77 0 0 1-.749.545 2.938 2.938 0 0 1-1.07.184c-.666 0-1.208-.149-1.622-.447-.409-.304-.62-.722-.632-1.254h1.01Z"
      fill="#000"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.907)" d="M0 0h11.222v12.96H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default CurationIllustration;
